import {createBrowserRouter} from "react-router-dom";

// project imports
import MainRoutes from "./MainRoutes";
import LoginRoutes from "./LoginRoutes";

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, LoginRoutes]);

export default router;
